import { reduceAction } from '@elab/core/store/helpers';

import types from './types';

export const initialState = () => ({
    products: [],
    checkedRemoveSamples: false,
    categoryCode: null,
    hideFreeSamples: true,
    clickedSample: null,
});

const reducers = (state = initialState(), { type, payload }) => {
    switch (type) {
        case types.SET_PRODUCTS: {
            const products = payload
                ? Array.isArray(payload)
                    ? [...payload]
                    : [...Object.values(payload)]
                : [];
            return { ...state, products };
        }

        case types.SET_REMOVE_SAMPLES_CHECKBOX:
            return reduceAction(state, 'checkedRemoveSamples', !!payload);

        case types.SET_CATEGORY_CODE:
            return reduceAction(state, 'categoryCode', payload);

        case types.SET_LOADING:
            return reduceAction(state, 'loading', payload);

        case types.SET_HIDE_FREE_SAMPLES:
            return reduceAction(state, 'hideFreeSamples', payload);

        case types.SET_ALLOWED_SAMPLES_CHANGED:
            return reduceAction(state, 'allowedSamplesChanged', payload);

        case types.SET_CLICKED_SAMPLE:
            return reduceAction(state, 'clickedSample', payload);
        default:
            return state;
    }
};

export default reducers;
